<template>
  <div class="collapsible-item" :class="blockClass">
    <h2 class="collapsible-item__title" v-bind:class="{ [blockClass + '__title']: blockClass }" @click="toggle">
      {{title}}
      <span class="collapsible-item__button" v-if="!opened"><svg width="12" height="8" viewBox="0 0 12 8" xmlns="http://www.w3.org/2000/svg"><path d="M1.41.087L6 4.677l4.59-4.59L12 1.507l-6 6-6-6z" fill-rule="evenodd" fill="currentColor"/></svg></span>
      <div class="collapsible-item__title-action" v-if="!opened">
        <slot name="title-action"></slot>
      </div>
    </h2>
    <div class="collapsible-item__content" v-bind:class="{[blockClass + '__content']: blockClass, 'collapsible-item__content--open': opened}">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'isOpened', 'blockClass', 'forceOpen'],
  data() {
    return {
      opened: false,
    }
  },
  mounted() {
    this.opened = this.forceOpen ? true : this.isOpened || false;
  },
  watch: {
    isOpened(val) {
      if ((val) !== this.opened) {
        this.toggle();
      }
    },
  },
  methods: {
    toggle() {
      if (this.forceOpen) return;
      this.opened = !this.opened;
      this.$parent.closeAll(this);
      if (this.opened) {
        this.$emit('opened', this.title);
      }
    },
    open() {
      if (this.forceOpen) return;
      this.opened = true;
    },
    close() {
      if (this.forceOpen) return;
      this.opened = false;
    }
  }
}
</script>
